module.exports = __webpack_public_path__ + "static/media/cuate.04d1bb76.png";